import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { layoutActions } from "./../../../redux/actionFunctions/layoutActions";
import Button from "../../../components/Button/Button";
import buildComponents from "./../../../../assets/image/builds.png";
import nutrientsLogo from "./../../../../assets/image/nutrients_logo.png";
import recommendedParts from "./../../../../assets/image/recommended_parts.png";
import xIcon from "./../../../../assets/image/xIcon.png";
import rightArrow from "./../../../../assets/image/right_arrow.png";
import imagePlaceholder from "./../../../../assets/image/imgPlaceholder.png";
import cartSummaryBg from "./../../../../assets/image/cartSummaryBg.jpg";
import Input from "../../../components/Input/Input";

import { Route, Switch as SwitchRoute } from "react-router-dom";
import NutrientCalculator from "./../NutrientCalculator/NutrientCalculator";
import BuildComponents from "./KitCart/BuildComponents";
import RecommendedParts from "./KitCart/RecommendedParts";
import * as roomFunctions from "./KitRoomFunctions";
import { useSelector } from "react-redux";
import Decimal from "decimal.js";
import Kit3DCanvas from "./KitCart/Kit3DCanvas";
import { useApolloClient } from "@apollo/client";
import cartFunctions from "./KitCartFunctions";
import ExtraForBuild from "./KitCart/ExtrasForBuild";
import { Popup } from "../../../layout/components/Popup/Popup";

let popupQIsOpenWeek = false;
let valueCopy = "0";

const WithPopup = (props) => {
  return (
    <div
      className="step-content kit-room-layout cart-popup bc-popup"
      page={props.page}
    >
      <div className="close-popup-wrapper cursor-pointer">
        <img src={xIcon} alt={"xIcon.png"} onClick={() => props.hidePopup()} />
      </div>
      {props.children}
    </div>
  );
};

export default function KitCart(props) {
  const { clientCartId } = useSelector(({ auth }) => ({
    clientCartId: auth?.user?.clientCartId,
  }));
  const [innerRouting, setInnerRouting] = React.useState({ page: undefined });
  const client = useApolloClient();
  const dispatch = useDispatch();

  /**
   * used for triggering an action after loader was rendered (to avoid setLoader off render trigger before setLoader on in cas request is faster than render )
   */
  const [loaderState, setLoaderState] = React.useState({
    key: undefined,
    action: undefined,
    callback: undefined,
  });

  const [state, setState] = React.useState({
    numOfPlants: 0,
    nutrientRemoved: false,
  });
  const [config, setConfig] = React.useState({
    configData: null,
    configDataLoadedKey: null,
  });

  const [customQuantities, setCustomQuantities] = React.useState({});
  const { popupQIsOpen } = useSelector(({ layout }) => {
    return {
      popupQIsOpen: Object.entries(layout.popupStack).some(
        ([key, value]) =>
          value.error_code === roomFunctions.nutrientErrors.CHANGES_LOST
      ),
    };
  });

  const valueRef = React.useRef("");

  const customValuesAdded = (forBuildComponents) =>
    forBuildComponents
      ? props.buildComponents.changed
      : Object.keys(customQuantities).length > 0;

  function setRightPopup(page) {
    setInnerRouting({
      page,
    });
  }

  function hidePopup() {
    setInnerRouting({
      page: undefined,
    });
  }

  function openPopup(payload) {
    let key = Date.now();
    layoutActions(dispatch).pushPopupStack({
      key,
      title: "",
      callbackNo: (closePopup) => {
        closePopup();
      },
      ...payload,
    });
  }

  function setNutrientData(name, value, ignorePopup) {
    if (!ignorePopup) {
      if (customValuesAdded(false) || customValuesAdded(true)) {
        if (!popupQIsOpen) {
          if (name === "week") {
            if (popupQIsOpenWeek === true) {
              return;
            }
            popupQIsOpenWeek = true;
          }
          onEmptyCustomQuantities(() => setNutrientData(name, value, true));
        }
        return;
      }
    }

    switch (name) {
      case "addCycles":
        props.setCalculatorState({
          ...props.calculatorState,
          addCycles: value,
        });
        break;
      case "flush":
        props.setCalculatorState({
          ...props.calculatorState,
          flush: value,
        });
        break;
      case "week":
        popupQIsOpenWeek = false;
        props.setCalculatorState({
          ...props.calculatorState,
          week: value,
        });
        break;
      default:
        break;
    }
  }

  function onSetCustomQuantities(value) {
    if (Object.entries(value).length === 0) {
      props.resetBuildComponents();
    }
    setCustomQuantities(value);
  }

  function onChangeCustomQuantity(property, value, ignorePopup) {
    if (value === undefined) {
      return;
    }
    if (!ignorePopup) {
      if (!customValuesAdded(false)) {
        if (!popupQIsOpen) {
          if (popupQIsOpenWeek === true) {
            return;
          }
          props.openPopup({
            ...roomFunctions.nutrientErrors.WARNING_BUILD_BREAK,
            content: roomFunctions.nutrientErrors.WARNING_BUILD_BREAK.message,
            callbackYes: (closePopup) => {
              popupQIsOpenWeek = false;
              onChangeCustomQuantity(property, value, true);
              closePopup();
            },
            callbackNo: (closePopup) => {
              closePopup();
              popupQIsOpenWeek = false;
            },
            buttoOkText: null,
          });
        }
        return;
      }
    }
    popupQIsOpenWeek = false;
    onSetCustomQuantities({
      ...customQuantities,
      [property]: value,
    });
  }

  function onEmptyCustomQuantities(callBack) {
    props.openPopup({
      ...roomFunctions.nutrientErrors.CHANGES_LOST,
      content: roomFunctions.nutrientErrors.CHANGES_LOST.message,
      callbackYes: (closePopup) => {
        callBack();
        onSetCustomQuantities({});
        closePopup();
        popupQIsOpenWeek = false;
      },
      callbackNo: (closePopup) => {
        closePopup();
        popupQIsOpenWeek = false;
      },
      buttoOkText: null,
    });
  }
  function setBuildLine(property, index, value, ignorePopup) {
    if (value === undefined) {
      return;
    }
    if (!ignorePopup) {
      if (!customValuesAdded(true)) {
        if (!popupQIsOpen) {
          if (popupQIsOpenWeek === true) {
            return;
          }
          valueRef.current = value;
          props.openPopup({
            ...roomFunctions.nutrientErrors.WARNING_BUILD_BREAK_COMPONENT,
            content:
              roomFunctions.nutrientErrors.WARNING_BUILD_BREAK_COMPONENT
                .message,
            callbackYes: (closePopup) => {
              popupQIsOpenWeek = false;
              setBuildLine(property, index, valueRef.current, true);
              closePopup();
            },
            callbackNo: (closePopup) => {
              closePopup();
              popupQIsOpenWeek = false;
            },
            buttoOkText: null,
          });
        }
        return;
      }
    }
    popupQIsOpenWeek = false;
    props.setBuildLine(property, index, value);
  }

  /**
   * includes all product with sku and quantity for each type of product {b1: [{sku, quantity, price, type='b1'}]}
   * !! includes those with quantity 0 as well so that need to be filtered out !!
   * !! includes other things that sku and quantity, so map accordingly !!
   * @param {object} allProductForCartNC
   * @param {Array} allProductForCartBM
   */
  function checkoutRoomBuilder(allProductForCartNC, allProductForCartBM) {
    if (
      !allProductForCartNC ||
      typeof allProductForCartNC !== "object" ||
      !Array.isArray(allProductForCartBM)
    ) {
      return;
    }
    if (loaderState.open && loaderState.action === "addToCart") {
      return;
    }
    setLoaderState({
      key: Date.now(),
      open: true,
      action: "addToCart",
      callback: () => {
        const items = [
          ...Object.entries(allProductForCartNC).reduce(
            (previous, [type, cItems]) => {
              cItems.forEach((line) => {
                if (line.quantity) {
                  previous.push({
                    sku: line.sku,
                    quantity: line.quantity,
                  });
                }
              });
              return previous;
            },
            []
          ),
          ...allProductForCartBM,
        ];
        // Object.entries(props.buildComponents).forEach(([key, value]) => {
        //   value.forEach((line) => {
        //     if (line.sku == "2437psux") {
        //       items.push({
        //         quantity: line.qty,
        //         parent_sku: line.sku,
        //         sku: "1501",
        //       });
        //     } else {
        //       items.push({
        //         quantity: line.qty,
        //         sku: line.sku,
        //       });
        //     }
        //   });
        // });
        cartFunctions(client)
          .addProductsToCart(items, clientCartId, props.selectedRoom)
          .then((items) => {
            let cartItems = [];
            if (Array.isArray(items)) {
              cartItems = items;
            }
            openExtrasForBuild(cartItems, clientCartId, props.selectedRoom);
          })
          .catch(() => {})
          .finally(() => {
            setLoaderState({
              open: false,
            });

            if (/^(http:\/\/localhost)/.test(window.location.href)) {
              return;
            }

            /* const cartAnchorNode = document.getElementById(
              "checkout-link-rm-kit-cart"
            );
            if (cartAnchorNode) {
              cartAnchorNode.click();
            } */
          });
      },
    });
  }

  function onRemoveNutrientSection() {
    setState({
      ...state,
      nutrientRemoved: true,
    });
    innerRouting.page === "nutrient-calculator" &&
      setInnerRouting({
        ...innerRouting,
        page: undefined,
      });
  }

  function nutrientSectionConfirmation() {
    openPopup({
      content: {
        title: "Are you sure you want to modify YOUR COMPONENTS?",
        text:
          <>The FloraFlex<sup>®</sup> Room Builder is designed to calculate the exact components needed for your build. However, you can add or subtract as desired. <br/><br/> <b>Please note FloraFlex<sup>®</sup> can not guarantee you will have sufficient/correct components if you edit your calculated components.</b></>,
      },
      buttonYes: "Continue",
      buttonNo: "Undo",
      className: "save-popup-",
      callbackYes: (closePopup) => {
        closePopup();
        onRemoveNutrientSection();
      },
    });
  }

  useEffect(() => {
    cartFunctions()
      .getConfig()
      .then((configData) => {
        setConfig({ configData, configDataLoadedKey: Date.now() });
      })
      .catch(() => {
        // let configData = JSON.parse(
        //   `{"top_of_page":"CALCULATE THE LBS YOU NEED FOR YOUR FULLTILT™ GROW","how_many_plants_question_text":"How many plants do you water a week? (4-5000)","volume_of_pot_question_text":"What is the volume of the pot, bag, or cube you are using? (.5-25 Gallons)","how_many_plants_range":{"min":4,"max":5000},"volume_of_pot_range":{"min":0.5,"max":25},"additional_bloom_weeks_range":{"min":0,"max":3},"below_question":" We recommend you adjust your starting EC to 0.3 with your preferred Cal and Mag","above_additional_weeks":"<p>All our FloraFlex Nutrients Schedules are designed to yield excellent result with an 8 week Bloom Stage. However, some strains may be improved by extending their Bloom Stage.</p><p>Are you planning to extend your Full Tilt grow by repeating Bloom week 5?</p>","additional_bloom_weeks_question_text":" How many additional weeks do you plan to add? (0-3)","above_additional_flush":"<p>Additionally, some strains may benefit from 2 weeks of Flush.</p><p>How many weeks of Flush do you intend?</p>","above_products_heading":"WHAT YOU'LL NEED","above_first_products_description":"At FloraFlex® we know our growers like having options.<br />Add FloraFlex® Nutrients individually or Add All to Cart for easy checkout and the perfect Full Tilt grow.","below_first_products_description":"Veg Stage: During only days 1, 7, 14, and 21 you’ll spray with Veg Foliar Refer to our <a href='https://floraflex.com/wp-content/uploads/2020/07/2020Formula_FullTilt.pdf' target='_blank'>FullTilt Schedule</a> for perfect ratios each week of V1™ and V2™","above_second_products_description":"","below_second_products_description":"Bloom Stage: During only days 1, 7, and 14 you’ll spray with Bloom Foliar Refer to our <a href='https://floraflex.com/wp-content/uploads/2020/07/2020Formula_FullTilt.pdf' target='_blank'>FullTilt Schedule</a> for perfect ratios each week of B1&trade, B2&trade, and FullTilt&trade","above_additional_cycles":"Add All To Cart to purchase all the Nutrients you will need for one grow cycle.<br />Add additional grow cycles and we will multiply your totals","additional_cycles_text":"Additional grow cycles","total_water_consumption":"TOTAL WATER CONSUMPTION","gallons_per_grow":"gallons_per_grow","above_learn_about_subscriptions":"Our Nutrients are also available as Subscriptions allowing us to automatically ship your Nutrients every 4, 8, or 12 weeks. Click the button below to learn more.","learn_about_subscriptions_button_text":"LEARN ABOUT OUR NUTRIENT SUBSCRIPTIONS","learn_about_subscriptions_url":"https://www.google.com/","above_download_full_tilt":"To help you complete your grow click the button below to download a Full Tilt Schedule pdf tailored to your grow duration.","download_full_tilt_button_text":"DOWNLOAD<br/>FULL TILT™ SCHEDULE","download_full_tilt_button_url":"https://floraflex.com/wp-content/uploads/2020/07/2020Formula_FullTilt.pdf","products":[{"key":"vf","name":"VEG FOLIAR","image":"https://floraflex.com/wp-content/uploads/2020/10/CalcIcons-Veg.png","1lb_sku":"1097","1lb_price":17.49,"5lb_sku":"1099","5lb_price":79.99,"10lb_sku":"1101","10lb_price":147.99,"25lb_sku":"1103","25lb_price":337.99,"productUrl":"/catalog/category/view/s/veg-foliar/id/138/"},{"key":"v1","name":"V1","image":"https://floraflex.com/wp-content/uploads/2020/10/CalcIcons-V1.png","1lb_sku":"805","1lb_price":17.49,"5lb_sku":"807","5lb_price":79.99,"10lb_sku":"809","10lb_price":147.99,"25lb_sku":"811","25lb_price":337.99,"productUrl":"/catalog/category/view/s/v1/id/139/"},{"key":"v2","name":"V2","image":"https://floraflex.com/wp-content/uploads/2020/10/CalcIcons-V2.png","1lb_sku":"817","1lb_price":19.99,"5lb_sku":"819","5lb_price":90.99,"10lb_sku":"821","10lb_price":165.99,"25lb_sku":"859","25lb_price":337.99,"productUrl":"/catalog/category/view/s/v2/id/140/"},{"key":"bf","name":"BLOOM FOLIAR","image":"https://floraflex.com/wp-content/uploads/2020/10/CalcIcons-Veg.png","1lb_sku":"1107","1lb_price":19.99,"5lb_sku":"1109","5lb_price":90.99,"10lb_sku":"845-1-1","10lb_price":165.99,"25lb_sku":"1113","25lb_price":375.99,"productUrl":"/catalog/category/view/s/bloom-foliar/id/141/"},{"key":"b1","name":"B1","image":"https://floraflex.com/wp-content/uploads/2020/10/CalcIcons-V1.png","1lb_sku":"829","1lb_price":17.49,"5lb_sku":"831","5lb_price":79.99,"10lb_sku":"833","10lb_price":147.99,"25lb_sku":"835","25lb_price":337.99,"productUrl":"/catalog/category/view/s/b1/id/142/"},{"key":"b2","name":"B2","image":"https://floraflex.com/wp-content/uploads/2020/10/CalcIcons-V2.png","1lb_sku":"841","1lb_price":19.99,"5lb_sku":"843","5lb_price":90.99,"10lb_sku":"845","10lb_price":165.99,"25lb_sku":"847","25lb_price":375.99,"productUrl":"/catalog/category/view/s/b2/id/143/"},{"key":"ft","name":"FULL TILT","image":"https://floraflex.com/wp-content/uploads/2020/10/CalcIcons-V2.png","1lb_sku":"1117","1lb_price":22.99,"5lb_sku":"1119","5lb_price":104.99,"10lb_sku":"1121","10lb_price":189.99,"25lb_sku":"1123","25lb_price":429.99,"productUrl":"/catalog/category/view/s/full-tilt/id/144/"}]}`
        // );
      });
  }, []);
  useEffect(() => {
    setState({
      ...state,
      numOfPlants: props.calculateNumOfPlants() || 1,
    });
  }, []);

  function openExtrasForBuild(cartItems, clientCartId, selectedRoom) {
    layoutActions(dispatch).pushPopupStack({
      key: "EXTRAS_FOR_BUILD_POPUP",
      title: "",
      callbackNo: (closePopup) => {
        closePopup();
      },
      content: {
        title: "",
        text: "",
        node: (
          <ExtraForBuild
            closePopup={() => {
              layoutActions(dispatch).popPopupStack({
                key: "EXTRAS_FOR_BUILD_POPUP",
              });
            }}
            editPopup={(payload) => {
              layoutActions(dispatch).editPopupStack({
                key: "EXTRAS_FOR_BUILD_POPUP",
                ...payload,
              });
            }}
            client={client}
            cartItems={cartItems}
            clientCartId={clientCartId}
            selectedRoom={selectedRoom}
          />
        ),
      },
      className: "wrapper-save-room-popup-rm-your-build",
    });
  }

  useEffect(() => {
    if (
      loaderState.action &&
      loaderState.key &&
      typeof loaderState.callback === "function"
    ) {
      loaderState.callback();
    }
  }, [loaderState.key]);

  const nutrientPayload = config.configData
    ? {
        flush: props.calculatorState.flush,
        plant: state.numOfPlants,
        volume: props.calculatorState.volume,
        week: props.calculatorState.week,
        addCycles: props.calculatorState.addCycles || 0,
        products: config?.configData?.products || [],
        customQuantities,
        ignoreQuantity: true, //get all products (quantity 0 as well)
      }
    : {
        allTotal: 0,
      };
  const nutrientResults = config.configData
    ? roomFunctions.culculateNutrientResults(nutrientPayload)
    : {
        allTotal: 0,
      };
  window.nutrientResults = nutrientResults;
  window.nutrientPayload = nutrientPayload;
  /**
   * ignore nutrient results if they are visually removed
   */
  if (state.nutrientRemoved) {
    nutrientResults.allProductForCart = {};
    nutrientResults.allTotal = 0;
  }
  const bCmpResults = roomFunctions.calculateComponentsResults({
    containers: props.buildComponents.containers || [],
    irrigation_style: props.buildComponents.irrigation_style || [],
    automation: props.buildComponents.automation || [],
    plant: state.numOfPlants,
  });

  let allCartSubtotal = new Decimal(Number(nutrientResults.allTotal) || 0).plus(
    bCmpResults.componentTotalDec
  );
  const plantNumTotalDec = new Decimal(Number(state.numOfPlants) || 0);
  const pricePerPlant = roomFunctions.toTwoDecimals(
    allCartSubtotal.dividedBy(plantNumTotalDec)
  );
  allCartSubtotal = roomFunctions.toTwoDecimals(allCartSubtotal);
  return (
    <>
      <div className="step-content kit-room-content kit-cart-summary">
        <div className="room-form">
          <div className="cart-title">
            <h1>YOUR CART</h1>
          </div>
          <a
            id="checkout-link-rm-kit-cart"
            href={`${window.BASE_URL}checkout/cart`}
            target=""
            style={{ display: "none" }}
          />
          <div className="cart-elements">
            <div className="element build-components">
              <div className="image-element">
                <img src={buildComponents} alt={"builds_image.png"} />
              </div>
              <div className="element-content">
                <div className="content-info">
                  <div className="text">
                    <div className="title">
                      BUILD
                      <br />
                      COMPONENTS
                    </div>
                    <div className="element-info">
                      {props.grow != null && props.grow != "" && (
                        <div>{props.grow}</div>
                      )}
                      {props.trayType != null && props.trayType != "" && (
                        <div>{props.trayType}</div>
                      )}
                      {props.irrigation != null && props.irrigation != "" && (
                        <div>{props.irrigation}</div>
                      )}
                      {props.setlectedPlantLabel != null &&
                        props.setlectedPlantLabel != "" && (
                          <div>{props.setlectedPlantLabel}</div>
                        )}
                    </div>
                  </div>
                  <img
                    className="element-extra c-pointer"
                    src={rightArrow}
                    alt={"arrow_right.png"}
                    onClick={() => setRightPopup("build-components")}
                  />
                </div>
                <div className="content-price">
                  <div className="price">
                    $
                    {(Number(bCmpResults.componentTotal) || 0).toLocaleString(
                      "en",
                      {
                        minimumFractionDigits: 2,
                      }
                    )}
                  </div>
                  {/* <img
                    className="delete-element c-pointer"
                    src={xIcon}
                    alt={"x_close.png"}
                  /> */}
                </div>
              </div>
            </div>

            {!state.nutrientRemoved && (
              <div className="element nutrients">
                <div className="image-element">
                  <img src={nutrientsLogo} alt={"flora_flex_nutrients.png"} />
                </div>
                <div className="element-content">
                  <div className="content-info">
                    <div className="text">
                      <div className="title">
                        FLORAFLEX<sup>®</sup>
                        <br />
                        NUTRIENTS
                      </div>
                      <div className="element-info">
                        GROW CYCLES
                        <Input
                          type="number"
                          placeholder=""
                          value={props.calculatorState.addCycles}
                          numericControl={true}
                          step={1}
                          min={1}
                          onChange={(event) => {
                            setNutrientData("addCycles", event.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <img
                      className="element-extra c-pointer"
                      src={rightArrow}
                      alt={"arrow_right.png"}
                      onClick={() => setRightPopup("nutrient-calculator")}
                    />
                  </div>
                  <div className="content-price">
                    <div className="price">
                      $
                      {nutrientResults.allTotal.toLocaleString("en", {
                        minimumFractionDigits: 2,
                      })}
                    </div>
                    <img
                      className="delete-element c-pointer"
                      src={xIcon}
                      alt={"x_close.png"}
                      onClick={nutrientSectionConfirmation}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="element recommended-parts">
              <div className="image-element">
                <img src={recommendedParts} alt={"recommended_parts.png"} />
              </div>
              <div className="element-content">
                <div className="content-info">
                  <div className="text">
                    <div className="title">
                      RECOMMENDED
                      <br />
                      3RD PARTY PARTS
                    </div>
                    <div className="element-info">
                      {props.thirdPartyParts?.pump?.title !== "" && (
                        <div className="third-p-item">
                          <div className="title-third-p-item">PUMP</div>
                          <span>{props.thirdPartyParts?.pump?.title}</span>
                          <br />
                          <span>{props.thirdPartyParts?.pump?.subtitle}</span>
                        </div>
                      )}
                      {props?.thirdPartyParts?.controller?.title !== "" && (
                        <div className="third-p-item">
                          <div className="title-third-p-item">CONTROLLER</div>
                          <span>
                            {props?.thirdPartyParts?.controller?.title}<br />{props.thirdPartyParts?.controller?.subtitle} {props.thirdPartyParts?.controller?.moduletext}
						  </span>
                        </div>
                      )}
                      {props.thirdPartyParts?.regulator?.title !== "" && (
                        <div className="third-p-item">
                          <div className="title-third-p-item">30 PSI REGULATOR</div>
                          <span>{props.thirdPartyParts?.regulator?.title}<br />{props.thirdPartyParts?.regulator?.subtitle}
						  </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <img
                    className="element-extra c-pointer"
                    src={rightArrow}
                    alt={"arrow_right.png"}
                    onClick={() => setRightPopup("3rd-party-parts")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Button text="Next" onClick={() => submitRoomSize()} /> */}
        <div className="cart-control">
          <div className="cart-control-border-top">
            <div></div>
          </div>
          <div className="cart-value">
            <div className="plant-price">
              PRICE PER PLANT:
              <span>
                {" "}
                $
                {pricePerPlant.toLocaleString("en", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
            <div className="cart-subtotal">
              CART SUBTOTAL:
              <span>
                {" "}
                $
                {allCartSubtotal.toLocaleString("en", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>
          <div className="kit-room-control">
            <Button
              text={<div> EDIT BUILD </div>}
              variant="secondary"
              className="kit-room-edit-btn"
              onClick={() => {
                props.history.replace({
                  pathname: "/kitbuilder/recommended-builds",
                  search: props.history.location.search,
                });
              }}
            />
            <Button
              text="CHECKOUT"
              variant="primary-new checkout-cart-btn"
              loading={loaderState.open && loaderState.action === "addToCart"}
              onClick={() =>
                checkoutRoomBuilder(
                  nutrientResults.allProductForCart,
                  bCmpResults.allProductForCart
                )
              }
            />
          </div>
        </div>
        <>
          {innerRouting.page === "build-components" && (
            <WithPopup hidePopup={hidePopup}>
              <BuildComponents
                containers={props.buildComponents.containers || []}
                irrigation_style={props.buildComponents.irrigation_style || []}
                automation={props.buildComponents.automation || []}
                setBuildLine={setBuildLine}
                componentPerPlantPrice={bCmpResults.componentPerPlantPrice}
                componentTotal={bCmpResults.componentTotal}
              />
            </WithPopup>
          )}
          {!state.nutrientRemoved &&
            innerRouting.page === "nutrient-calculator" && (
              <WithPopup hidePopup={hidePopup} page="calculator">
                <NutrientCalculator
                  flush={props.calculatorState.flush}
                  plant={state.numOfPlants}
                  volume={props.calculatorState.volume}
                  week={props.calculatorState.week}
                  addCycles={props.calculatorState.addCycles}
                  setNutrientData={setNutrientData}
                  nutrientResults={nutrientResults}
                  configData={config.configData}
                  configDataLoadedKey={config.configDataLoadedKey}
                  onChangeCustomQuantity={onChangeCustomQuantity}
                  customQuantitiesAreNotEmpty={!customValuesAdded(false)}
                />
              </WithPopup>
            )}
          {innerRouting.page === "3rd-party-parts" && (
            <WithPopup hidePopup={hidePopup}>
              <RecommendedParts thirdPartyParts={props?.thirdPartyParts} />
            </WithPopup>
          )}
        </>
      </div>
    </>
  );
}
